// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.space {
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/load-control-group-form/load-control-group-form.component.scss","webpack://./src/components/general%20components/load-control-group-form/load-control-group-form.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;ACCJ","sourcesContent":[".space {\n    white-space: normal;\n}",".space {\n  white-space: normal;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
